import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import DataLoadingLayer from '../components/DataLoadingLayer';

const DataLoadingPage = () => (
  <MasterLayout pageTitle='Bulk Data Import'>
    <DataLoadingLayer />
  </MasterLayout>
);

export default DataLoadingPage;
